import axios from "axios";

let BaseURLValue = "";
if (process.env.REACT_APP_ENV === 'development') BaseURLValue = process.env.REACT_APP_BASE_URL_DEVELOPMENT
else if (process.env.REACT_APP_ENV === 'staging') BaseURLValue = process.env.REACT_APP_BASE_URL_STAGING
else if (process.env.REACT_APP_ENV === 'production') BaseURLValue = process.env.REACT_APP_BASE_URL_PRODUCTION

let FileBaseURL = "";
if (process.env.REACT_APP_ENV === 'development') FileBaseURL = process.env.REACT_APP_FILES_DEVELOPMENT_BASE_URL
else if (process.env.REACT_APP_ENV === 'staging') FileBaseURL = process.env.REACT_APP_FILES_STAGING_BASE_URL
else if (process.env.REACT_APP_ENV === 'production') FileBaseURL = process.env.REACT_APP_FILES_PRODUCTION_BASE_URL

let imgBaseURL = "";
if (process.env.REACT_APP_ENV === 'development') imgBaseURL = process.env.REACT_APP_IMAGE_DEVELOPMENT_URL
else if (process.env.REACT_APP_ENV === 'production') imgBaseURL = process.env.REACT_APP_IMAGE_PRODUCTION_URL

let apiKey = "";
if (process.env.REACT_APP_ENV === 'development') apiKey = process.env.REACT_APP_X_API_KEY
else if (process.env.REACT_APP_ENV === 'production') apiKey = process.env.REACT_APP_PRODUCTION_X_API_KEY

const Admin = axios.create({
  baseURL: BaseURLValue + process.env.REACT_APP_VERSION_1,
  headers: {
    "x-api-key": apiKey,
    "Content-Type": "application/json; charset=utf-8"
  },
});
const AdminFile = axios.create({
  baseURL: BaseURLValue + process.env.REACT_APP_VERSION_1,
  headers: {
    "x-api-key": apiKey,
    "Content-Type": "multipart/form-data"
  },
});

AdminFile.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

Admin.interceptors.request.use(
  function (config) {
    console.log(config, "config")
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export { BaseURLValue, FileBaseURL, AdminFile, imgBaseURL, apiKey };
export default Admin;

